import React from 'react';
import LeftSide from "../../sides/LeftSide";
import RightSide from "../../sides/RightSide";
import MidSide from "./MidSide";
import {connect} from 'react-redux';
import {fetchResults} from '../../../redux/actions/resultActions';
import moment from "moment";
import MidSideDrawing from "./MidSideDrawing";
import _ from "lodash";

const MT = ({...props}) => {

    const {drawResult: {data}, historyResult} = props;

    const onChangeDate = (value) => {
        window.location.href = "/ket-qua-xo-so/" + moment(value).format("DD-MM-yyyy") + ".html";
    };
    return (
        <div className="dnw-content-layout">
            <div className="dnw-content-main" id="dnw-content-main">
                <div className="dnw-content-main-l">
                    <div className="dnw-content-main-r">
                        <table cellSpacing="0" cellPadding="0">
                            <tbody>
                            <tr>
                                <LeftSide isDrawing={!_.isEmpty(data)} {...props} onChangeDate={(date) => onChangeDate(date)}/>
                                {
                                    _.isEmpty(data) ? <MidSide results={historyResult} draw={data} {...props}
                                                               onChangeDate={(date) => onChangeDate(date)}/>
                                        : <MidSideDrawing results={historyResult} draw={data} {...props}
                                                          onChangeDate={(date) => onChangeDate(date)} isDrawing/>
                                }
                                <RightSide/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );

};

const mapStateToProps = state => ({
    historyResult: state.result.result,
    drawResult: state.result.draw
});


export default connect(
    mapStateToProps,
    {
        fetchResults
    }
)(MT);
